<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">{{newConsultant ? 'Add Consultant' : 'Edit Consultant'}}</h5>
  <div class="d-flex align-items-center gap-2 ms-auto">
    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="openAuditForForm()" title="History" *ngIf="!newConsultant">
      <fa-icon [icon]="faHistory"></fa-icon>
    </button>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
  </div>
</div>

<div class="modal-body">
  <form [formGroup]="consultantDetails" autocomplete="off">

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Name</label>
        <input class="form-control" placeholder="Name" maxlength="50" formControlName="name">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Email Address</label>
        <input class="form-control" placeholder="Email Address" maxlength="100" formControlName="emailAddress">
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Postcode</label>
        <input class="form-control" placeholder="Postcode" maxlength="25" formControlName="postcode">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">County</label>
        <input class="form-control" placeholder="County" maxlength="250" formControlName="borough">
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Phone Number</label>
        <input class="form-control" placeholder="Phone Number" maxlength="250" formControlName="phoneNumber">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Fees</label>
        <input class="form-control" placeholder="Fees" maxlength="250" formControlName="fees">
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Number of Days Worked Per Week</label>
        <input class="form-control" placeholder="Number of Days" maxlength="100" formControlName="numberDaysWorkedPerWeek">
      </div>
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Days of the Week Worked</label>
        <input class="form-control" placeholder="Days of the Week" maxlength="100" formControlName="daysOfTheWeekWorked">
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-sm-6">
        <label class="form-label fw-semibold">Distance Willing to Travel (Miles)</label>
        <input class="form-control" placeholder="Miles" type="number" min="0" formControlName="milesWillingToTravel">
      </div>
      <div class="col-sm-6" *ngIf="!newConsultant">
        <label class="form-label fw-semibold">Active</label>
        <app-yes-no-form-toggle class="d-block" formControlName="active"></app-yes-no-form-toggle>
      </div>
    </div>

  </form>
</div>

<div class="modal-footer">

  <ng-container *ngIf="!newConsultant">
    <button *ngIf="updatingConsultant" type="button" class="btn btn-success" disabled>
      <span class="spinner-border spinner-border-sm" role="status"></span>
      Updating...
    </button>
    <button *ngIf="!updatingConsultant" type="button" class="btn btn-success" (click)="saveConsultant()">Update</button>
  </ng-container>

  <ng-container *ngIf="newConsultant">
    <button *ngIf="updatingConsultant" type="button" class="btn btn-success" disabled>
      <span class="spinner-border spinner-border-sm" role="status"></span>
      Saving...
    </button>
    <button *ngIf="!updatingConsultant" type="button" class="btn btn-success" (click)="addConsultant()">Save</button>
  </ng-container>
</div>